import { render, staticRenderFns } from "./royalties.vue?vue&type=template&id=231f1146&scoped=true"
import script from "./royalties.vue?vue&type=script&lang=js"
export * from "./royalties.vue?vue&type=script&lang=js"
import style0 from "./royalties.vue?vue&type=style&index=0&id=231f1146&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231f1146",
  null
  
)

export default component.exports